/**
 * catalog-card-cycle.js
 *
 * Upcoming catalogs have no meaningful view data yet (the catalog hasn't
 * gone live), so instead of a fixed top-3 lot grid, snippets/catalog-card.liquid
 * embeds the whole product list on .catalog-card__lots[data-cycle-products]
 * and this rotates a random 3 of them into view every few seconds - giving
 * more of the catalog's products some exposure rather than always showing
 * the same three. Live catalogs use a real top-3-by-views ranking instead
 * (rendered server-side, no cycling) - this script only ever touches
 * containers that opted in via data-cycle-products.
 */
(function () {
  var CYCLE_INTERVAL_MS = 5000;
  var FADE_MS = 250;

  var prefersReducedMotion = false;
  try {
    prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function pickRandom(pool, count, avoid) {
    var candidates = pool.slice();
    // Prefer products not currently shown, so a swap always looks like a
    // swap - falls back to allowing repeats only if the pool is too small.
    if (avoid && avoid.length && candidates.length > count) {
      var avoidSet = {};
      avoid.forEach(function (p) { avoidSet[p.id] = true; });
      var filtered = candidates.filter(function (p) { return !avoidSet[p.id]; });
      if (filtered.length >= count) candidates = filtered;
    }
    var picked = [];
    while (picked.length < count && candidates.length) {
      var idx = Math.floor(Math.random() * candidates.length);
      picked.push(candidates.splice(idx, 1)[0]);
    }
    return picked;
  }

  function renderLot(p, catalogId) {
    var img = p.image
      ? '<img class="catalog-card__lot-img" src="' + esc(p.image) + '" alt="' + esc(p.title || '') + '" loading="lazy">'
      : '<div class="catalog-card__lot-img catalog-card__lot-img--placeholder" aria-hidden="true"></div>';
    return '<a class="catalog-card__lot" href="' + esc(p.url) + '" data-track-product-id="' + esc(p.id) + '" data-track-catalog-id="' + esc(catalogId) + '">' + img + '</a>';
  }

  function setupCycler(container) {
    var raw;
    try {
      raw = JSON.parse(container.getAttribute('data-cycle-products') || '[]');
    } catch (e) {
      raw = [];
    }
    if (!Array.isArray(raw) || raw.length <= 3) return; // nothing to rotate into

    var catalogId = container.getAttribute('data-cycle-catalog-id') || '';
    var current = Array.prototype.slice.call(container.querySelectorAll('.catalog-card__lot')).map(function (a) {
      return { id: a.getAttribute('data-track-product-id') };
    });

    if (prefersReducedMotion) return; // static server-rendered 3 stays as-is

    // Preload every image in the next trio before touching the DOM at all -
    // without this, the fade-in reveals blank/loading boxes for however long
    // the network takes, then the images pop in abruptly a moment later.
    // Preloading first means the swap only ever happens once everything is
    // already decoded and sitting in the browser's cache, so the fade-in
    // shows the real image instantly.
    function preloadImages(products, callback) {
      var remaining = products.length;
      var done = false;
      function checkDone() {
        if (done) return;
        remaining--;
        if (remaining <= 0) {
          done = true;
          callback();
        }
      }
      if (remaining === 0) { callback(); return; }
      products.forEach(function (p) {
        if (!p.image) { checkDone(); return; }
        var img = new Image();
        img.onload = checkDone;
        img.onerror = checkDone;
        img.src = p.image;
      });
      // Safety net: a slow or broken image shouldn't stall the cycle forever.
      setTimeout(function () {
        if (!done) { done = true; callback(); }
      }, 4000);
    }

    var isSwapping = false;

    function swap() {
      if (isSwapping) return;
      // Skip a cycle instead of animating a card that's scrolled off/hidden
      // (closed tab, collapsed accordion, etc.) - no point paying the reflow.
      if (document.visibilityState !== 'visible') return;
      var rect = container.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;

      var next = pickRandom(raw, 3, current);
      if (!next.length) return;

      isSwapping = true;
      preloadImages(next, function () {
        current = next;
        container.classList.add('catalog-card__lots--fading');
        setTimeout(function () {
          container.innerHTML = next.map(function (p) { return renderLot(p, catalogId); }).join('');
          container.classList.remove('catalog-card__lots--fading');
          isSwapping = false;
        }, FADE_MS);
      });
    }

    setInterval(swap, CYCLE_INTERVAL_MS);
  }

  function init() {
    document.querySelectorAll('.catalog-card__lots[data-cycle-products]').forEach(function (el) {
      if (el.dataset.cycleBound === 'true') return;
      el.dataset.cycleBound = 'true';
      setupCycler(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
